import {
  Directive,
  DOCUMENT,
  ElementRef,
  HostListener,
  Inject,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges,
} from '@angular/core';

@Directive({
  selector: '[appToggleDisplay]',
  standalone: true,
})
export class ToggleDisplayDirective implements OnChanges {
  @Input() elementToToggle: ElementRef;
  @Input() hiddenClass = 'd-none';
  @Input() overflowHiddenClass = 'overflow-hidden';
  @Input() isShowing = false;

  constructor(
    private readonly renderer: Renderer2,
    @Inject(DOCUMENT) private readonly document: Document
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.elementToToggle) {
      this.toggleElement(this.isShowing);
    }
  }

  @HostListener('click') onClick(): void {
    this.toggleElement();
  }

  toggleElement(force = null): void {
    if (!this.elementToToggle) {
      return;
    }

    if (force === null) {
      this.isShowing = !this.isShowing;
    } else {
      this.isShowing = force;
    }

    if (this.isShowing) {
      this.renderer.removeClass(this.elementToToggle, this.hiddenClass);
    } else {
      this.renderer.addClass(this.elementToToggle, this.hiddenClass);
    }

    this.handleBodyScrolling();
  }

  handleBodyScrolling(): void {
    const body = this.document.body;
    const hasVerticalScrollbar = body.scrollHeight > body.clientHeight;

    if (this.isShowing) {
      this.renderer.addClass(body, this.overflowHiddenClass);
      if (hasVerticalScrollbar) {
        this.renderer.setStyle(body, 'padding-right', '17px');
      }
    } else {
      this.renderer.removeClass(body, this.overflowHiddenClass);

      if (hasVerticalScrollbar) {
        this.renderer.removeStyle(body, 'padding-right');
      }
    }
  }
}
